enum AppMode {
	NONE = 'NONE',
	ADMINISTRATION_ADD_ELIGIBILITY_MESSAGE_PRIORITY = 'ADMINISTRATION_ADD_ELIGIBILITY_MESSAGE_PRIORITY',
	ADMINISTRATION_ADD_MIN_COST_PER_SQUARE_FOOT = 'ADMINISTRATION_ADD_MIN_COST_PER_SQUARE_FOOT',
	ADMINISTRATION_ADD_MIN_COST_PER_SQUARE_FOOT_VERSION = 'ADMINISTRATION_ADD_MIN_COST_PER_SQUARE_FOOT_VERSION',
	ADMINISTRATION_EDIT_ELIGIBILITY_MESSAGE_PRIORITY = 'ADMINISTRATION_EDIT_ELIGIBILITY_MESSAGE_PRIORITY',
	ADMINISTRATION_EDIT_MIN_COST_PER_SQUARE_FOOT = 'ADMINISTRATION_EDIT_MIN_COST_PER_SQUARE_FOOT',
	ADMINISTRATION_EDIT_MIN_COST_PER_SQUARE_FOOT_VERSION = 'ADMINISTRATION_EDIT_MIN_COST_PER_SQUARE_FOOT_VERSION',
	ADDRESS_VERIFICATION_SINGLE_LINE = 'ADDRESS_VERIFICATION_SINGLE_LINE',
	ADDRESS_VERIFICATION = 'ADDRESS_VERIFICATION',
	ADDRESS_COORDINATE_SELECTION = 'ADDRESS_COORDINATE_SELECTION',
	ADDRESS_COORDINATE_CHANGE = 'ADDRESS_COORDINATE_CHANGE',
	BUILDING_ADDRESS_VERIFICATION_SINGLE_LINE = 'BUILDING_ADDRESS_VERIFICATION_SINGLE_LINE',
	BUILDING_ADDRESS_VERIFICATION = 'BUILDING_ADDRESS_VERIFICATION',
	BUILDING_COORDINATE_SELECTION = 'BUILDING_COORDINATE_SELECTION',
	BUILDING_COORDINATE_CHANGE = 'BUILDING_COORDINATE_CHANGE',
	ADD_BUILDING = 'ADD_BUILDING',
	DELETE_BUILDING = 'DELETE_BUILDING',
	CHANGE_BUILDING_ADDRESS = 'CHANGE_BUILDING_ADDRESS',
	ADD_MORTGAGEE = 'ADD_MORTGAGEE',
	EDIT_MORTGAGEE = 'EDIT_MORTGAGEE',
	DELETE_MORTGAGEE = 'DELETE_MORTGAGEE',
	ELIGIBILITY_NOTIFICATION = 'ELIGIBILITY_NOTIFICATION',
	ADD_POLICY_NOTE = 'ADD_POLICY_NOTE',
	ADD_NOTE_TO_POLICY_NOTE = 'ADD_NOTE_TO_POLICY_NOTE',
	CHANGE_POLICY_NOTE_FLAG_DATE = 'CHANGE_POLICY_NOTE_FLAG_DATE',
	MARK_POLICY_NOTE_COMPLETE = 'MARK_POLICY_NOTE_COMPLETE',
	ARCHIVE_POLICY_NOTE = 'ARCHIVE_POLICY_NOTE',
	OFAC_NOTIFICATION = 'OFAC_NOTIFICATION',
	POLICY_SEARCH_RESULTS = 'POLICY_SEARCH_RESULTS',
	CHANGE_PRODUCER_AGENT = 'CHANGE_PRODUCER_AGENT',
	CHANGE_PRODUCER_AGENCY = 'CHANGE_PRODUCER_AGENCY',
	UNSUBMIT_NEW_BUSINESS_APPLICATION = 'UNSUBMIT_NEW_BUSINESS_APPLICATION',
	COPY_POLICY_TO_NEW_BUSINESS_APPLICATION = 'COPY_POLICY_TO_NEW_BUSINESS_APPLICATION',
	RESUBMIT_NEW_BUSINESS_APPLICATION = 'RESUBMIT_NEW_BUSINESS_APPLICATION',
	MAKE_CHANGES_NOTIFICATION = 'MAKE_CHANGES_NOTIFICATION',
	SEARCH_POLICIES = 'SEARCH_POLICIES',
	DOWNLOAD_PDF = 'DOWNLOAD_PDF',
	VIEW_POLICY_NOTES = 'VIEW_POLICY_NOTES',
	VIEW_POLICY_NOTE_EMAILS = 'VIEW_POLICY_NOTE_EMAILS',
	VIEW_ELIGIBILITY_RESULTS = 'VIEW_ELIGIBILITY_RESULTS',
	MOBILE_SIDE_BAR = 'MOBILE_SIDE_BAR',
	ADD_POLICY_NOTE_ADMIN = 'ADD_POLICY_NOTE_ADMIN',
	SESSION_TIMEOUT = 'SESSION_TIMEOUT',
	CALCULATING_PREMIUM = 'CALCULATING_PREMIUM',
	SWITCH_TO_LEGACY_VERSION = 'SWITCH_TO_LEGACY_VERSION',
	CHANGE_ENDORSEMENT_DATE = 'CHANGE_ENDORSEMENT_DATE',
	CHANGE_INVALID_ENDORSEMENT_DATE_FOR_SUBMISSION = 'CHANGE_INVALID_ENDORSEMENT_DATE_FOR_SUBMISSION',
	CHANGE_INVALID_ENDORSEMENT_DATE_FOR_CALCULATION = 'CHANGE_INVALID_ENDORSEMENT_DATE_FOR_CALCULATION',
	VIEW_ENDORSEMENT_PREMIUM_BREAK_DOWN = 'VIEW_ENDORSEMENT_PREMIUM_BREAK_DOWN',
	VIEW_ENDORSEMENT_PREMIUM_CALCULATION_INFO = 'VIEW_ENDORSEMENT_PREMIUM_CALCULATION_INFO',
	REVIEW_ENDORSEMENT_ACKNOWLEDGEMENTS = 'REVIEW_ENDORSEMENT_ACKNOWLEDGEMENTS',
}

export default AppMode;